import {
	Avatar,
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogTitle,
	Grid,
	IconButton,
	Typography,
	useTheme,
} from "@mui/material";
import React, { useState } from "react";
import constants from "../Constants";
import DeleteIcon from "@mui/icons-material/Delete";
import AlertMsg from "./AlertMsg";
import Axios from "axios";
import Constants from "../Constants";

function SlideList({ sliders, fetchSlideList }) {
	const [deleteModal, setDeleteModal] = useState(false);
	const [deleteMsg, setDeleteMsg] = useState(null);
	const [data, setData] = useState();
	const theme = useTheme();

	const deleteSlide = async id => {
		try {
			const response = await Axios.delete(Constants.baseUrl + "/slide/" + id, {
				headers: {
					authorization: "Bearer " + localStorage.getItem("schoolToken"),
				},
			});
			const status = response.data.status;
			if (status === 202) {
				fetchSlideList();
				setDeleteMsg({
					type: true,
					header: "عملیات با موفقیت انجام شد.",
					message: "تبلیغ با موفقیت حذف شد",
				});
				setDeleteModal(false);
			} else {
				setDeleteMsg({
					type: false,
					header: "تلاش ناموفق",
					message: response.data.result.message,
				});
			}
		} catch (err) {
			setDeleteMsg({
				type: false,
				header: "تلاش ناموفق",
				message: "خطا در برقراری ارتباط",
			});
		}
	};

	return (
		<Grid container gap={1} justifyContent={"center"} my={1}>
			{sliders.map(item => (
				<Grid
					item
					xs={12}
					sx={{
						backgroundColor: "#ebebeb",
						display: "flex",
						alignItems: "center",
						justifyContent: "space-between",
						borderRadius: 3,
						p: 2,
					}}
					key={item.id}>
					<Avatar
						variant="square"
						src={`${constants.baseUrl}/slide/show/${item.image}`}
						sx={{
							width: 110,
							height: 60,
							objectFit: "contain",
							[theme.breakpoints.down("sm")]: { width: 100, height: 60 },
						}}
						alt="slideImage"></Avatar>
					<Box
						textAlign={"right"}
						sx={{ [theme.breakpoints.down("sm")]: { mr: 1 } }}>
						<Typography>عنوان : {item.title}</Typography>
						<Typography>لینک : {item.link}</Typography>
					</Box>
					<IconButton
						edge="start"
						onClick={() => {
							setDeleteModal(true);
							setData(item);
						}}>
						<DeleteIcon />
					</IconButton>
				</Grid>
			))}
			<Dialog
				open={deleteModal}
				onClose={() => {
					setDeleteModal(false);
				}}
				fullWidth
				maxWidth="sm">
				<DialogTitle>آیا از حذف این تبلیغ اطمینان دارید ؟</DialogTitle>
				{deleteMsg
					? !deleteMsg.type && <AlertMsg message={deleteMsg} type={"error"} />
					: null}
				<DialogActions sx={{ gap: 2 }}>
					<Button
						variant="contained"
						color="primary"
						onClick={() => {
							setDeleteModal(false);
						}}>
						انصراف
					</Button>
					<Button
						variant="contained"
						color="secondary"
						sx={{ color: "white" }}
						onClick={() => {
							deleteSlide(data.id);
							setDeleteModal(false);
						}}
						autoFocus>
						تایید
					</Button>
				</DialogActions>
			</Dialog>
		</Grid>
	);
}

export default SlideList;
